import React from "react";

import { FAQCard } from "pages/home/faq/FAQCard";
import { home } from 'texts/texts';
import { TextWithStyle } from "components/TextWithStyle";

export const faqData = [
  {
    question: "How can I partner with Toastie?",
    plainAnswer: "We'd love to work with you! For partnership enquiries, please contact us at hello@toastie.au and we will get back to you as soon as we can!",
    answer: (
      <>
        We'd love to work with you! For partnership enquires, please contact us at <a href="mailto:hello@toastie.au">hello@toastie.au</a> and we will get back to you as soon as we can!
      </>
    )
  },
  {
    question: "This looks amazing! How do I get started with using Toastie?",
    plainAnswer: "You can download Toastie today on the iOS App Store or Google Play.",
    answer: (
      <>
        You can download us today on the{" "}
        <a
          href="https://apps.apple.com/au/app/toastie-health-tracker/id6736644572"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          🍎 iOS App Store
        </a>{" "}
        or get us on{" "}
        <a
          href="https://play.google.com/store/apps/details?id=au.toastie.health.tracker"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          👾 Google Play
        </a>
        .
      </>
    )
  },
  {
    question: "How can I make a feature request or report a bug?",
    plainAnswer: "In the Settings page on the mobile app, tap on 'Send Feedback' under the Resources heading, or fill out our feedback form. We love and appreciate hearing your feedback and will address it as quickly as we can!",
    answer: (
      <>
        In the Settings page on the mobile app, tap on 'Send Feedback' under the Resources heading. Or alternatively, fill out {" "}
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSeaY4A9fwisx5QOZ2GpZTmbs6aDs2ThcSOw1Lnsh4E6huyFWA/viewform"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          this form
        </a>{""}
        . We love and appreciate hearing your feedback and will address it as quickly as we can!
      </>
    )
  },
  {
    question: "Why are you called 'Toastie'?",
    plainAnswer: "We wanted a name that felt fun, cute, and cosy - not cold or clinical like so many health apps. Toasted white bread is the go-to safe food during flare ups for our co-founder Anna (who has lots of food intolerances), so Toastie is a nod to that and a reminder that comfort and care should always be part of your health journey.",
    answer: (
      <>
      We wanted a name that felt <em>fun</em>, <em>cute</em>, and <em>cosy</em> - not cold or clinical like so many health apps. On a personal note: toasted white bread 🍞 is the go-to safe food during flare ups for our co-founder Anna (who has lots of food intolerances). So Toastie is both a little nod to that, and a reminder that <em>comfort and care</em> should always be part of your health journey 💖
      </>
    )
  },
];

export const FAQSection: React.FC = () => {
  return (
    <section id="faq" className="home-content-container faq">
        <div className="eyebrow">
          <span className="eyebrow-dot"></span>
            Faqs
        </div>
        <h3>{home.faq.title.map((part, index) => (
            <TextWithStyle key={index} text={part.text} style={part.style} />
          ))}</h3>
        {faqData.map((faq, index) => (
          <FAQCard key={index} question={faq.question} answer={faq.answer} />
        ))}
    </section>
  );
};
